import React, { useEffect, useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap'
import axios from "axios";
import AuthService from "../../controllers/AuthService";
import UserService from "../../controllers/UserService";
import { useParams } from 'react-router-dom';

const ReportFriendship = props => {
    const [evaluate, setEvaluate] = useState([]);
    const { roomId } = useParams();
    const userId = AuthService.getCurrentUser().id

    useEffect(() => {

        try {
            UserService.getFriendShipList(userId, { roomId }).then((response) => {
                if (response.data.status.code === 'SUCCESS' && response.data.data && response.data && response.data.data[0] && response.data.data[0].others) {
                    console.log(response.data.data[0].others)
                    const data = response.data.data[0].others
                    const me = data.filter(function (d) { return d.user.id === userId })[0];

                    let t1 = data.filter(function (d) { return d.user.roles.includes("TEACHER") && d.answerAt !== null });

                    if (t1[0]) {
                        t1 = t1[0];
                    } else {
                        t1 = data.filter(function (d) { return d.user.roles.includes("TEACHER") })[0];
                    }

                    const friends = data.filter(function (d) { return d.user.roles.includes("STUDENT") && d.user.id !== userId });
                    const ansFriends = data.filter(function (d) { return d.user.roles.includes("STUDENT") && d.user.id !== userId && d.answers !== null });
                    let fText = ''
                    if (ansFriends.length === friends.length) {
                        fText = `<img src="/images/evaluate/book1-green.png" class="d-inline w-15" /> <span class="already-evaluate font-sarabun-bold">ทำประเมินครบแล้ว</span><p class="font-sarabun"><a href="/report/friendship/friends/${roomId}" class="green-text underline-text">รายละเอียด</a></p><br><Button class="bluesky d-inline py-1 py-md-1 btn font-sarabun-bold mt-4" onClick="(function(){window.open('/report/friendship/export/friends/${roomId}/${userId}', '_blank').focus();return false;})();return false;">Export</Button>`
                    } else if (ansFriends.length === 0) {
                        // fText = `<img src="/images/evaluate/book1.png" class="d-inline" /> <span class="gray-text4 font-sarabun-bold">เพื่อนยังไม่ได้ทำประเมิน (${ansFriends.length}/${friends.length})</span><p class="font-sarabun green-text underline-text">รายละเอียด</p><br><Button class="bluesky d-inline py-1 py-md-1 btn font-sarabun-bold btn-disable">Export</Button>`
                        fText = `<span class="gray-text4 font-sarabun-bold">เพื่อนยังไม่ได้ทำประเมิน (${ansFriends.length}/${friends.length})</span><p class="font-sarabun green-text underline-text">รายละเอียด</p><br><Button class="bluesky d-inline py-1 py-md-1 btn font-sarabun-bold btn-disable">Export</Button>`
                    } else if (ansFriends.length < friends.length) {
                        // fText = `<img src="/images/evaluate/book1-yellow.png" class="d-inline" /> <span class="text-yellow-evaluate font-sarabun-bold">เพื่อนยังประเมินไม่ครบ (${ansFriends.length}/${friends.length})</span><p class="font-sarabun"><a href="/report/friendship/friends/${roomId}" class="green-text underline-text">รายละเอียด</a></p><br><Button class="bluesky d-inline py-1 py-md-1 btn font-sarabun-bold" onClick="(function(){window.open('/report/friendship/export/friends/${roomId}/${userId}', '_blank').focus();return false;})();return false;">Export</Button>`
                        fText = `<span class="text-yellow-evaluate font-sarabun-bold">เพื่อนยังประเมินไม่ครบ (${ansFriends.length}/${friends.length})</span><p class="font-sarabun"><a href="/report/friendship/friends/${roomId}" class="green-text underline-text">รายละเอียด</a></p><br><Button class="bluesky d-inline py-1 py-md-1 btn font-sarabun-bold" onClick="(function(){window.open('/report/friendship/export/friends/${roomId}/${userId}', '_blank').focus();return false;})();return false;">Export</Button>`
                    }

                    setEvaluate(
                        {
                            "me":
                            {
                                "answer": me.answers !== null ? `<img src="/images/evaluate/book1-green.png" class="d-inline w-15" /> <span class="already-evaluate font-sarabun-bold">ทำประเมินครบแล้ว</span><p class="font-sarabun"><a href="/report/friendship/me/${roomId}" class="green-text underline-text">รายละเอียด</a></p><br><Button class="bluesky d-inline py-1 py-md-1 btn font-sarabun-bold mt-4 mt-md-4" onClick="(function(){window.open('/report/friendship/export/me/${roomId}/${userId}', '_blank').focus();return false;})();return false;">Export</Button>` : '<span class="font-sarabun-bold grey-blue-text me-margin-bottom">ยังไม่ประเมิน</span><p class="font-sarabun green-text underline-text">รายละเอียด</p><br><Button class="bluesky d-inline py-1 py-md-1 btn font-sarabun-bold btn-disable mt-4 mt-md-4">Export</Button>',
                                "done": me.answers !== null
                            },
                            "t1":
                            {
                                "answer": t1.answers !== null ? `<img src="/images/evaluate/book1-green.png" class="d-inline w-15" /> <span class="already-evaluate font-sarabun-bold">ทำประเมินครบแล้ว</span><p class="font-sarabun"><a href="/report/friendship/teacher/${roomId}" class="green-text underline-text">รายละเอียด</a></p><br><Button class="bluesky d-inline py-1 py-md-1 btn font-sarabun-bold mt-4" onClick="(function(){window.open('/report/friendship/export/teacher/${roomId}/${userId}', '_blank').focus();return false;})();return false;">Export</Button>` : '<span class="font-sarabun-bold grey-blue-text me-margin-bottom">คุณครูยังไม่ได้ประเมิน</span><p class="font-sarabun green-text underline-text">รายละเอียด</p><br><Button class="bluesky d-inline py-1 py-md-1 btn font-sarabun-bold btn-disable mt-4">Export</Button>',
                                "done": t1.answers !== null
                            },
                            "friends": {
                                "answer": fText,
                                "done": ansFriends.length !== 0
                            }
                        }
                    )

                }
            });
        } catch (error) {

        }

    }, []);

    const goto = (target, newTab = false) => {
        if (target && newTab) {
            window.open(target, '_blank').focus();
        } else if (target) {
            window.location.href = `/report/friendship/${target}/${roomId}`
        }
    }

    return (
        <div className="report-friendship">
            <Row className="bg-light-blue py-5">
                <Col className="main-evaluate-overview pb-3 mb-3">
                    <Row>
                        <Col xs={12} md={6} className="w-100 text-center">
                            <img src='/images/evaluate/banner_overview.png' className="mb-1 d-inline pr-2 w-100" />
                        </Col>
                        <Col xs={12} md={6} className="w-100 pt-3" align="center">
                            <h3 class="font-sarabun-bold pt-md-5 primary-text">ดาวน์โหลดสมุด Friendship</h3>
                            <h3 class="font-sarabun-bold primary-text">{AuthService.getUserFullName()}</h3>
                            <Button className="bluesky d-inline py-1 py-md-1 btn font-sarabun-bold" onClick={() => goto(`/report/friendship/export/all/${roomId}/${userId}`, true)}>Export</Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row>
                <Col className="main-evaluate-overview">
                    <Row className="mx-2">
                        {/* <Col xs={12} md={12} className="border-radius-12 border-blue caption-box caption-box-114 click-pointer" onClick={() => { if ((evaluate.me && evaluate.me.done) || (evaluate.t1 && evaluate.t1.done) || (evaluate.friends && evaluate.friends.done)) { goto('self-development') } }}>
                            <h2 class="text-center font-sarabun-bold">แนวทางการพัฒนาตัวเอง</h2>               
                        </Col> */}
                        <Col xs={12} md={12} className="border-radius-12 border-blue caption-box caption-box-114">
                            <h2 class="text-center font-sarabun-bold">แนวทางการพัฒนาตัวเอง</h2>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className="mb-2 mt-m-3">
                <Col className="main-evaluate-overview p-0 p-md-3 ">
                    <Row className="mx-3 mb-5">
                        <Col xs={12} className="px-3 pt-4 pb-3 d-inline w-100 text-center">
                            <h3 className="primary-text font-sarabun-bold">ดูรายละเอียดแบบแยกมุมมอง</h3>
                        </Col>
                        <Col xs={4} className={`px-1 px-md-3 w-100 text-center table-border ${evaluate.me && evaluate.me.done ? '-click-pointer' : ''}`}>
                            <img src='/images/report-friendship/me.png' className="pt-3 round-icon" />
                            <h4 className="font-sarabun-bold grey-dark-text">มุมมองตัวเอง</h4>
                            <p dangerouslySetInnerHTML={{ __html: evaluate.me && evaluate.me.answer ? evaluate.me.answer : '' }} />
                        </Col>
                        <Col xs={4} className={`px-1 px-md-3 w-100 text-center table-border ${evaluate.t1 && evaluate.t1.done ? '-click-pointer' : ''}`}>
                            <img src='/images/report-friendship/teacher.png' className="pt-3 round-icon" />
                            <h4 className="font-sarabun-bold grey-dark-text">มุมมองคุณครู</h4>
                            <p dangerouslySetInnerHTML={{ __html: evaluate.t1 && evaluate.t1.answer ? evaluate.t1.answer : '' }} />
                        </Col>
                        <Col xs={4} className={`px-1 px-md-3 w-100 text-center table-border ${evaluate.friends && evaluate.friends.done ? '-click-pointer' : ''}`}>
                            <img src='/images/report-friendship/friends.png' className="pt-3 round-icon" />
                            <h4 className="font-sarabun-bold grey-dark-text">มุมมองเพื่อน</h4>
                            <p dangerouslySetInnerHTML={{ __html: evaluate.friends && evaluate.friends.answer ? evaluate.friends.answer : '' }} />

                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    )

}

export default ReportFriendship